import React from 'react'
import PropTypes from 'prop-types'
import { useContainerWidth, colors } from '@fs/zion-ui'
import { TextAndIconButton, useSquishyButton } from '@fs/zion-ui/quarks-authorized-use-only'
import { css } from '@linaria/core'
import { useTranslation } from 'react-i18next'
import { HelpAi } from '@fs/zion-icon'

const buttonCss = css`
  padding: 12px 20px;
  text-transform: capitalize;
  border-radius: 2em;
  font-size: var(--text-size-b);

  background-color: ${colors.gray100};
  color: ${colors.gray00};

  /* remove UA bevel */
  appearance: none;
  border: 0;
  outline: 0;
  box-shadow: none;

  /* smoother transitions */
  transition:
    background-color 160ms ease,
    transform 160ms ease;
  will-change: background-color, transform;
  transform-origin: center;

  &:hover:not([aria-disabled='true']):not(:active) {
    background-color: ${colors.gray70};
    transform: scale(var(--button-scale, 1.06));
  }

  &:focus-visible {
    outline: 3px solid ${colors.gray90};
    outline-offset: 2px;
    background-color: ${colors.gray70};
    transform: scale(var(--button-scale, 1.06));
  }

  &:active {
    background-color: ${colors.gray100};
    transform: scale(1);
  }
`

export default function ChatbotLaunchPillButton({ overlay, onClickOverride }) {
  const { t } = useTranslation()
  const atWidth = useContainerWidth()
  const buttonScale = useSquishyButton(overlay.targetRef)

  return (
    <TextAndIconButton
      className={buttonCss}
      ref={overlay.targetRef}
      title={t('help-overlay-button.text', 'Get Help')}
      emphasis="high"
      Icon={HelpAi}
      onClick={onClickOverride || overlay.handleClick}
      size={atWidth({ sm: 'md', md: 'lg' })}
      data-testid="help-overlay-lower-left"
      linkName="help-chatbot:open"
      style={{ '--button-scale': buttonScale }}
    >
      {t('help-overlay-button.text', 'Get Help')}
    </TextAndIconButton>
  )
}

ChatbotLaunchPillButton.propTypes = {
  overlay: PropTypes.shape({
    targetRef: PropTypes.object.isRequired,
    handleClick: PropTypes.func.isRequired,
  }).isRequired,
  onClickOverride: PropTypes.func,
}
